import { DebugImagesStore } from './DebugImagesStore';

export default DebugImagesStore;
